import React from "react";
import { observer } from "mobx-react-lite";
import { TextField, FormControlLabel, Checkbox, CircularProgress } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { ButtonStyled } from "./LoginForm.styles";
import { useMst } from "../../../../../mobx";

export interface LoginOptions {
  username: string;
  password: string;
  rememberMe: boolean;
}

export default observer(function () {
  const { control, handleSubmit } = useForm<LoginOptions>();
  const { authStore } = useMst();
  const { login, isLoading } = authStore;

  return (
    <form onSubmit={handleSubmit(handleLoginUser)}>
      <Controller
        render={({ field }) => (
          <TextField
            {...field}
            inputProps={{ "aria-label": "username" }}
            label="E-mail адрес"
            variant="outlined"
            size="small"
            margin={"normal"}
            fullWidth
          />
        )}
        control={control}
        name={"username"}
        defaultValue={localStorage.getItem("username") || ""}
      />
      <Controller
        render={({ field }) => (
          <TextField
            {...field}
            inputProps={{ "aria-label": "password" }}
            label="Пароль"
            variant="outlined"
            type="password"
            size="small"
            margin={"normal"}
            fullWidth
          />
        )}
        control={control}
        name={"password"}
        defaultValue={""}
      />
      <Controller
        name={"rememberMe"}
        control={control}
        defaultValue={JSON.parse(localStorage.getItem("rememberMe") || "false")}
        render={({ field: { onChange, value } }) => {
          return (
            <FormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={(_, checked) => onChange(checked)}
                  color={"primary"}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              label={"Запомнить меня"}
            />
          );
        }}
      />
      <ButtonStyled
        data-testid={"signin-button"}
        disabled={isLoading}
        variant="contained"
        type="submit"
        color="primary"
        size={"medium"}
        fullWidth
      >
        {isLoading ? <CircularProgress size={24} color={"secondary"} /> : "Вход"}
      </ButtonStyled>
    </form>
  );

  async function handleLoginUser(data: LoginOptions) {
    await login(data);
  }
});
